import React from 'react';
import ReactDOM from 'react-dom/client';
import '@src/css/theme/light.scss';
import '@src/css/theme/dark.scss';
import '@src/css/normalize.css';
import "@src/css/extend.scss";
import "@src/css/animate.scss";
import 'windi.css';
import 'virtual:svg-icons-register';
import 'antd/dist/reset.css';
import '@src/css/antd-theme/index.scss';
import 'core-js/es/object/has-own';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import App from './app';

pdfjs.GlobalWorkerOptions.workerSrc = '/worker/pdf.worker.min.js?v=8';

if (!window.__root) {
  window.__root = ReactDOM.createRoot(document.getElementById('nworld-app-container'));
}
window.__root.render(<App />);
